import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { colors } from '../../../../theme';
import { Colors } from '../../../../utils/Colors';

const S = {
    Root: styled('div')({
        display: 'flex',
        minHeight: '100px',
        justifyContent: 'center',
        alignItems: 'start',
        paddingLeft: '24px',
        paddingRight: '24px',
        backgroundColor: colors.black2,
        flexDirection: 'column',
        gap: '10px',
        marginTop: '10px',
        paddingTop: '10px',
        paddingBottom: '20px'
    }),
    labelTitle: {
        height: '17px',
        marginTop: '14px',
        color: colors.white90,
        fontWeight: '600',
        fontFamily: 'Inter',
        fontSize: '14px',
        lineHeight: '16.94px'
    },
    PrListContainer: styled(Box)({
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginTop: '16px'
    }),
    PrItem: styled(Box)({
        padding: '12px 16px',
        backgroundColor: colors.darkBluebg,
        borderRadius: '8px',
        border: `1px solid ${colors.white30}`,
        '&:hover': {
            borderColor: Colors.lightningYellow
        }
    }),
    prUrl: {
        color: Colors.lightningYellow,
        fontWeight: '500',
        fontFamily: 'Inter',
        fontSize: '13px',
        lineHeight: '20px',
        wordBreak: 'break-all'
    },
    emptyMessage: {
        color: colors.white30,
        fontWeight: '400',
        fontFamily: 'Inter',
        fontSize: '13px',
        lineHeight: '20px',
        fontStyle: 'italic',
        marginTop: '8px'
    }
};

export default S;
